<template>
    <div class="left-item">
        <router-link to="/dashboard">
            <!-- <p> {{ title }} </p> -->
            <p> {{ isHidden ? 'PCT' : 'Price Comparison Tool' }} </p>
            <!-- <img src="@/assets/switch.png" alt="PCT Logo"> -->
        </router-link>
    </div>
</template>

<script>

export default {
    data () {
        return {
            isHidden: false,
            title: 'Price Comparison Tool',
            width: 1000
        }
    },
    computed: {

    },
    created () {
        this.width = window.innerWidth        
        // this.width < 1000 ? this.isHidden = 'PCT' : this.isHidden= 'Price Comparison Tool'
        this.width < 1000 ? this.isHidden = true : this.isHidden = false        

        let self = this
        this.$nextTick(function () {
            window.addEventListener('resize', function (event) {
                self.width = window.innerWidth
                self.width < 1000 ? self.isHidden = true : self.isHidden = false
                // self.width < 1000 ? self.isHidden = 'PCT' : self.isHidden= 'Price Comparison Tool'
            })
            
        })
        
    }
}
    
</script>

<style scoped>
    @media only screen and (min-width: 1000px) {
        .left-item {
            width: 200px;
            height: 100%;
            background-color: #21262e;
            
        }
    }
    @media only screen and (min-width: 320px) and (max-width: 999px) {
        .left-item {
            width: 64px;
            height: 100%;
            background-color: #21262e;
        }
        img {
            display: none
        }
    }
    .left-item a{
        font-weight: bold;
        width: 200px;
        height: 100%;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .left-item div {
        z-index: 9;   
    }
    
    img {
        width: 75%;
        margin-top: 15px;
    }

    p {
        color: white;
        text-transform: uppercase;
        border: none;
        text-decoration: none;
        padding-left: 3px;
        /* margin-left: 15px !important; */
        margin: 0 0 0 15px;
        line-height: 60px;
        font-size: 0.9em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Headers/NavLeft.vue